// extracted by mini-css-extract-plugin
export default {"link":"Link_link__WLorY","primary":"Link_primary__X497l","secondary":"Link_secondary__SGLQ7","underlined":"Link_underlined__s1BeX","bold":"Link_bold__8Roya"};